import { persistProject } from "./helpers/persistProject";

export function setUnits(unitType) {
  return persistProject({type: 'RECEIVED_NEW_UNIT_TYPE', unitType});
}

export function setTestUnit(testUnitType) {
  return persistProject({type: 'RECEIVED_NEW_TEST_UNIT_TYPE', testUnitType});
}

export function set(settings) {
  return persistProject({type: 'SET_PROJECT_SETTINGS', settings});
}

export default {
  setUnits,
  setTestUnit,
  set,
};
